<template>
  <div>
    <PlanComponentVue mode="edit" />
  </div>
</template>
<script>
import PlanComponentVue from "./PlanComponent.vue";

export default {
  components: {
    PlanComponentVue,
  },
};
</script>
